import type { ChecklistItem } from "./checklist";
import type { RequestedDocumentRequirement } from "./document-requirements";

/** A configured item as a checklist row. */
type ConfiguredRequirement = Omit<ChecklistItem, "id" | "resolutionIds"> & {
  key: string;
  kind: "checklist_item";
};

/** Configured items plus this task's own requested documents. */
export type ChecklistRequirement = ConfiguredRequirement | RequestedDocumentRequirement;

/** Only a requested document can be concluded as nonexistent, recorded as a waiver. */
export const isRequirementDismissable = (requirement: ChecklistRequirement): boolean =>
  requirement.kind === "requested_document";
